import { render } from "./getuipush.vue?vue&type=template&id=0080d2a0&scoped=true"
import script from "./getuipush.vue?vue&type=script&lang=js"
export * from "./getuipush.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0080d2a0"]])

export default __exports__